import "./App.css";
import React, { useState, useEffect } from "react";

import { Introduce } from "./components/Introduce";
import { Introduce1 } from "./components/Introduce1";
import { Section1 } from "./components/Section-1";
import { Section2 } from "./components/Section-2";
import { Section3 } from "./components/Section-3";
import { Section4 } from "./components/Section-4";
import { Section5 } from "./components/Section-5";
import { generateUUID } from "./utils/generateUUID";


import { Alert, Steps, Modal, Form, Button, Dropdown, Menu, Drawer } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { MenuOutlined } from "@ant-design/icons";



const flowSteps = [
  {
    title: "LỜI MỞ ĐẦU",
    description: "",
  },
  {
    title: "HƯỚNG DẪN",
    description: "",
  },
  {
    title: "PHẦN 1",
    description:
      <p style={{ fontSize: "13px" }} >TRẢI NGHIỆM METRO CỦA NGƯỜI THAM GIA KHẢO SÁT</p>,
  },
  {
    title: "PHẦN 2",
    description: <p style={{ fontSize: "13px" }} >KHẢO SÁT HÀNH VI THAM GIA GIAO THÔNG</p>,
  },
  {
    title: "PHẦN 3",
    description: <p style={{ fontSize: "13px" }} >THÁI ĐỘ VÀ NHẬN THỨC</p>,
  },
  {
    title: "PHẦN 4",
    description: <p style={{ fontSize: "13px" }} >LỰA CHỌN LOẠI HÌNH DI CHUYỂN TÍCH HỢP MỚI (MAAS)</p>,
  },
  {
    title: "PHẦN 5",
    description: <p style={{ fontSize: "13px" }} >THÔNG TIN CHUNG CỦA NGƯỜI THAM GIA KHẢO SÁT</p>,
  },
];
function App() {



  const [open, setOpen] = useState(false);
  const handleStepChange = (step) => {
    setCurrentStep(step);
    setOpen(false); // Tự động đóng Drawer sau khi chọn bước
  };

  const [currentStep, setCurrentStep] = useState(0);
  const [currentVehicle, setCurrentVehicle] = useState();
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  const [outputData, setOutputData] = useState({});

  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  // scroll lên đầu khi có sự thay đổi
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

  }, [currentStep]); // Chạy lại khi currentStep thay đổi



  const isMobile = width <= 768;

  useEffect(() => { }, []);
  useEffect(() => {
    console.debug("outputData:", outputData);
  }, [outputData]);

  const handleSubmit = (value, section, nextStep) => {
    // console.log("section:",section);
    console.log("currentStep:", currentStep);
    console.log("add data:", value);

    if (!validateSection(currentStep))
      return;

    // setOutputData({ ...outputData, [section]: value });
    setOutputData({ ...outputData, [currentStep]: value });
    if (nextStep === flowSteps.length) {
      console.log("post form!");
      // const formData = { ...outputData, [section]: value };
      const formData = { ...outputData, [nextStep]: value };
      console.log("post!" + Object.keys(formData).length);

      // console.log(formData);
      console.log(flowSteps.length);

      if (Object.keys(formData).length != flowSteps.length) {
        setShowError(true);
        setTimeout(() => {
          setShowError(false);
        }, 2000);
      } else {
        // alert("post form");
        console.log("post data: ", formData);
        postSurveys(formData);
        setShowSuccess(true);
      }
    } else if (nextStep != undefined) {
      setCurrentStep(nextStep);
    }
  };
  const handleFail = () => {
    // nếu để như này khi lỗi sẽ quay lại bước trươc
    // setCurrentStep(currentStep-1);

  };

  const sendDataToFirebase = async (data) => {
    try {
      const response = await fetch(
        "https://khaosatmetro-hiro-default-rtdb.asia-southeast1.firebasedatabase.app/.json",
        {
          method: "POST", // Gửi dữ liệu lên Firebase
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      if (!response.ok) {
        throw new Error("Lỗi khi gửi dữ liệu!");
      }

      const result = await response.json();
      console.log("Dữ liệu đã gửi thành công:", result);
    } catch (error) {
      console.error("Lỗi:", error);
    }
  };

  // Gọi hàm với dữ liệu mẫu


  const postSurveys = (data) => {
    console.log("start post data", data);

    const my_id = generateUUID();
    const ts = Date.now();
    const date = new Date(ts);
    console.log(date.toLocaleString()); // Kết quả: "2/4/2025, 15:08:50" (tùy múi giờ)

    const myInit = {
      body: {
        id: my_id,
        timestamp: ts,
        time: date.toLocaleString(),
        value: JSON.stringify(data),
      },
    };
    console.log("post data: ", myInit);
    sendDataToFirebase(myInit);
    // API.post("api0302", "/surveys", myInit)
    //   .then((result) => {
    //     console.debug("postSurveys:", result);
    //   })
    //   .catch((err) => {
    //     console.error("postSurveys error:", err);
    //   });
  };
  const validateSection = (sectionIndex) => {
    switch (sectionIndex) {
      case 0:
        return true;
      case 1:
        return true;
      case 2:
        return true;
      case 3:
        return true;
      case 4:
        return true;
      case 5:
        return true;
      case 6:
        return true;
      case 7:
        return true;
    }
    return false;
  };
  const onChange = (value) => {
    if (value === 0) {
      setCurrentStep(value);
      return;
    }
    if (validateSection(currentStep)) {
      setCurrentStep(value);
    } else {
    }
  };
  // if (isMobile) {
  //   return (
  //     <div className="fixed top-[40vh] left-[30vw] w-[40vw] z-50">
  //       <Alert
  //         description="Vui lòng thực hiện khảo sát trên máy tính."
  //         type="warning"
  //         showIcon
  //         closable={false}
  //         onClose={() => {
  //           // window.location.reload();
  //         }}
  //       />
  //     </div>
  //   );
  // }
  const menu = (
    <Menu>
      {flowSteps.map((step, index) => (
        <Menu.Item key={index} onClick={() => setCurrentStep(index)}>
          {step.title}
        </Menu.Item>
      ))}
    </Menu>
  );
  return (
    <div style={{ paddingLeft: "10%", paddingRight: "10%", paddingTop: "3%", paddingBottom: "10%" }}>
      {showError && (
        <div className="fixed top-[40vh] left-[30vw] w-[40vw] z-50">
          <Alert
            description="Vui lòng trả lời đầy đủ câu  hỏi"
            type="error"
            showIcon
            closable
            onClose={() => setShowError(false)}
          />
        </div>
      )}
      {showSuccess && (
        <div className="fixed top-[40vh] left-[30vw] w-[40vw] z-50">
          <Alert
            description="Cảm ơn anh/chị đã tham gia khảo sát"
            type="success"
            showIcon
            closable
            onClose={() => {
              window.location.reload();
            }}
          />
        </div>
      )}

      {/* <div className="w-[15vw] fixed left-[3vw] top-[3vh]">
        <Steps
          current={currentStep}
          direction="vertical"
          onChange={onChange}
          items={flowSteps}
        />
      </div> */}



      <div className="w-full max-w-[300px] mx-auto">
        {/* Nút mở Drawer chỉ hiển thị trên mobile */}
        {isMobile && (
          <div>
            <Button icon={<MenuOutlined />} onClick={() => setOpen(true)}>
              <span>Menu: {flowSteps[currentStep].title}</span>
            </Button>
          </div>
        )}

        {/* Drawer chứa Steps trên mobile */}
        <Drawer
          title="Các bước khảo sát"
          placement="left"
          closable
          onClose={() => setOpen(false)}
          open={open}
        >
          <Steps
            size="small"
            progressDot
            current={currentStep}
            direction="horizontal"
            items={flowSteps}
            onChange={handleStepChange}
          />
        </Drawer>

        {/* Steps hiển thị trên PC (Bỏ phần "Bước hiện tại") */}
        {/* {!isMobile && (
          <div className="fixed left-[3vw] top-0 w-[15vw]">
            <Steps
              type="navigation"
              current={currentStep}
              direction="horizontal"
              items={flowSteps}
              onChange={handleStepChange}
            />
          </div>
        )}
      </div> */}
        {!isMobile && (

          <Steps
            size="small"
            progressDot
            current={currentStep}
            direction="horizontal"
            items={flowSteps}
            onChange={handleStepChange}
            style={{ fontSize: "2px" }}

          />

        )}
        {/* <div className="">
          <Button
            className="bg-green border-red-500 border-2"
            onClick={postSurveys}
          >
            TEST
          </Button>
        </div> */}
        {/* {currentStep === 0 && <Introduce />} */}
        <div className={currentStep === 0 ? "" : "hidden"}>
          <Introduce
            title={flowSteps[currentStep]?.description}
            handleSubmit={(value, nextStep) => {
              handleSubmit(value, flowSteps[currentStep].description, nextStep);
            }}
            handleFail={handleFail}
            currentStep={currentStep}
            flowStepsLenght={flowSteps.length}
          />
        </div>

        <div className={currentStep === 1 ? "" : "hidden"}>
          <Introduce1
            title={flowSteps[currentStep]?.description}
            handleSubmit={(value, nextStep) => {
              handleSubmit(value, flowSteps[currentStep].description, nextStep);
            }}
            handleFail={handleFail}
            currentStep={currentStep}
            flowStepsLenght={flowSteps.length}
          />
        </div>

        <div className={currentStep === 2 ? "" : "hidden"}>
          <Section1
            title={flowSteps[currentStep]?.description}
            handleSubmit={(value, nextStep) => {
              handleSubmit(value, flowSteps[currentStep].description, nextStep);
            }}
            handleFail={handleFail}
            currentStep={currentStep}
            flowStepsLenght={flowSteps.length}
          />
        </div>

        <div className={currentStep === 3 ? "" : "hidden"}>
          <Section2
            title={flowSteps[currentStep]?.description}
            handleSubmit={(value, nextStep) =>
              handleSubmit(value, flowSteps[currentStep]?.description, nextStep)
            }
            handleFail={handleFail}
            currentStep={currentStep}
            flowStepsLenght={flowSteps.length}
          />
        </div>

        <div className={currentStep === 4 ? "" : "hidden"}>
          <Section3
            title={flowSteps[currentStep]?.description}
            handleSubmit={(value, nextStep) => {
              handleSubmit(
                value,
                flowSteps[currentStep]?.description,
                nextStep
              );
              // console.debug("vehicle: ",value?.["Phương tiện chính sử dụng Anh/Chị sử dụng hàng ngày"])
              if (
                value?.["Phương tiện chính sử dụng Anh/Chị sử dụng hàng ngày"]
              ) {
                setCurrentVehicle(
                  value?.["Phương tiện chính sử dụng Anh/Chị sử dụng hàng ngày"]
                );
              }
            }}
            handleFail={handleFail}
            currentStep={currentStep}
            flowStepsLenght={flowSteps.length}
          />
        </div>

        <div className={currentStep === 5 ? "" : "hidden"}>
          <Section4
            title={flowSteps[currentStep]?.description}
            currentVehicle={currentVehicle}
            handleSubmit={(value, nextStep) =>
              handleSubmit(value, flowSteps[currentStep]?.description, nextStep)
            }
            handleFail={handleFail}
            currentStep={currentStep}
            flowStepsLenght={flowSteps.length}
          />
        </div>
        <div className={currentStep === 6 ? "" : "hidden"}>
          <Section5
            title={flowSteps[currentStep]?.description}
            handleSubmit={(value, nextStep) =>
              handleSubmit(value, flowSteps[currentStep]?.description, nextStep)
            }
            handleFail={handleFail}
            currentStep={currentStep}
            flowStepsLenght={flowSteps.length}
          />
        </div>
      </div>
    </div>
  );
}

export default App;
